// extracted by mini-css-extract-plugin
module.exports = {"rich-text-base":"styles_rich-text-base__x2j6B","button-base":"styles_button-base__eIDD_"};